const getUrlParameter = ( sParam ) => {
  const sPageURL = window.location.search.substring( 1 );
  const sURLVariables = sPageURL.split( '&' );

  for (let i = 0; i < sURLVariables.length; i++) {
    const sParameterName = sURLVariables[i].split( '=' );

    if (sParameterName[0] === sParam) {
      return typeof sParameterName[1] === 'undefined' ? true : decodeURIComponent( sParameterName[1] );
    }
  }
};

const firstStepQuote = ( event, formSelector, fieldsSelector ) => {
  let hasError = false;
  // Getting all the form field values
  const fields = $( fieldsSelector )
    .map( ( index, input ) => ({
      name: $( input ).attr( 'name' ),
      value: $( input ).val().trim()
    }) ).get();

  const { isEmptyRequiredField } = createValidation( formSelector );

  fields.forEach( field => isEmptyRequiredField( field ) ? hasError = true : null );

  if (hasError) {
    event.preventDefault();
    $( `${formSelector} .first-step .button` ).attr( 'disabled', false ).removeClass( 'disabled' );
    return false;
  }

  const fieldsObject = fields.reduce( ( result, field ) => ({
    ...result,
    [field.name]: field.value
  }), {} );

  // Sending request
  $.post( '/apincm.php/quote-step1', mapFirstStepFormToRequest( fieldsObject ) )
    .done( response => {
      const quote = JSON.parse( response );
      $( `${formSelector} .first-step` ).hide();
      $( `${formSelector} .booking-info` ).show();
      $( `${formSelector} .booking-info input[name=quoteId]` ).val( quote[0].id );
      $( `${formSelector} .booking-info input[name=GUID]` ).val( quote[0].gu_id );
    } )
    .fail( jqXHR => {
      const errors = JSON.parse( jqXHR.responseText );
      showFormErrors( errors, formSelector );
    } )
    .always( () => $( `${formSelector} .first-step .button` ).attr( 'disabled', false ).removeClass( 'disabled' ) );
};

const secondStepQuote = ( event, formSelector, fieldsSelector ) => {
  let hasError = false;
  // Getting all the form field values
  const fields = $( fieldsSelector ).map( ( index, input ) => ({
    name: $( input ).attr( 'name' ),
    value: $( input ).val().trim()
  }) ).get();

  const { isEmptyRequiredField, isValidEmail, isDigitField } = createValidation( formSelector );
  fields.forEach( field => {
    if (field.name !== 'phone' && isEmptyRequiredField( field )) {
      hasError = true;
    }
    if (field.name === 'email') {
      if (!isValidEmail( field )) {
        hasError = true;
      }
    }
    if (field.name === 'phone') {
      if (!isDigitField( field )) {
        hasError = true;
      }
    }
  } );

  if (hasError) {
    event.preventDefault();
    $( `${formSelector} .second-step .button` ).attr( 'disabled', false ).removeClass( 'disabled' );
    return false;
  }

  const fieldsObject = fields.reduce( ( result, field ) => ({
    ...result,
    [field.name]: field.value
  }), {} );

  $.post( '/apincm.php/quote-step2', mapSecondStepFormToRequest( fieldsObject ) )
    .done( response => {
      const quoteId = $( `${formSelector} input[name=quoteId]` ).val();
      const GUID = $( `${formSelector} input[name=GUID]` ).val();
      const url = $( `${formSelector} input[name=quoteUrl]` ).val();
      if (quoteId && GUID) {
        window.location = `${url}?id=${quoteId}&GUID=${GUID}`;
      }
    } )
    .fail( jqXHR => {
      const errors = JSON.parse( jqXHR.responseText );
      showFormErrors( errors, formSelector );
    } )
    .always( () => $( `${formSelector} .second-step .button` ).attr( 'disabled', false ).removeClass( 'disabled' ) );
};

const nonCarQuoteForm = ( event, formSelector, fieldsSelector ) => {
  let hasError = false;
  // Getting all the form field values
  const fields = $( fieldsSelector ).map( ( index, input ) => ({
    name: $( input ).attr( 'name' ),
    value: $( input ).val().trim()
  }) ).get();

  const { isEmptyRequiredField, isValidEmail, isDigitField } = createValidation( formSelector );

  fields.forEach( field => {
    if (field.name !== 'phone' && isEmptyRequiredField( field )) {
      hasError = true;
    }
    if (field.name === 'email') {
      if (!isValidEmail( field )) {
        hasError = true;
      }
    }
    if (field.name === 'phone') {
      if (!isDigitField( field )) {
        hasError = true;
      }
    }
  } );

  if (hasError) {
    $( `${formSelector} .second-step .button` ).attr( 'disabled', false ).removeClass( 'disabled' );
    return false;
  }

  const fieldsObject = fields.reduce( ( result, field ) => ({
    ...result,
    [field.name]: field.value
  }), {} );

  $.post( '/apincm.php/quote-non-car', mapNonCarFormToRequest( fieldsObject ) )
    .done( response => {
      const quote = JSON.parse( response );
      const url = $( `${formSelector} input[name=quoteUrl]` ).val();
      window.location = `${url}?id=${quote[0].id}&GUID=${quote[0].guid}`;
    } )
    .fail( jqXHR => {
      const errors = JSON.parse( jqXHR.responseText );
      showFormErrors( errors, formSelector );
    } )
    .always( () => $( `${formSelector} .second-step .button` ).attr( 'disabled', false ).removeClass( 'disabled' ) );
};

const showFormErrors = ( errors, formSelector ) =>
  errors.map( error => {
    const errorFieldName = mapErrorsToForm( error );
    $( `${formSelector} .${errorFieldName}-error` ).html( error.message ).show();
  } );

const changeQuotationForm = ( formSelector ) => {
  $( `${formSelector} .error-message` ).hide();
  const isCar = $(`${formSelector} .vehicles-dropdown .text span` ).attr( 'data-is-car' );
  if (isCar) {
    if (+isCar) {
      $( `${formSelector} .non-car-transport-details` ).hide();
      $( `${formSelector} .car-transport-details` ).show();
      $( `${formSelector} .booking-info` ).hide();
      $( `${formSelector} .form-button.first-step` ).show();
    } else {
      $( `${formSelector} .car-transport-details` ).hide();
      $( `${formSelector} .non-car-transport-details` ).show();
      $( `${formSelector} .booking-info` ).show();
      $( `${formSelector} .form-button.first-step` ).hide();
    }
  }
};